import * as THREE from "three";
import {
    DEFAULT_ARTWORK_MODEL_URL,
    FRAME1_ARTWORK_MODEL_URL,
    FRAME1_PPRT_ARTWORK_MODEL_URL
} from "../artwork.constants";
import { ArtworkWrapper } from "@/types/artworksData";

export class ArtworkFrame {

    static ensureFrameData(artworkWrapper: ArtworkWrapper) {
        if (!artworkWrapper.artworks[artworkWrapper.activeArtwork].artworkData.frame) {
            artworkWrapper.artworks[artworkWrapper.activeArtwork].artworkData.frame = {
                type: "default",
                artworkWrapperID: artworkWrapper._id,
                color: "#000000",
                thickness: 1,
                pasPartoutSize: 0.1
            }
        }
    }

    static getFrameUrl(type: string): string {
        switch (type) {
            case "default":
                return DEFAULT_ARTWORK_MODEL_URL;
            case "frame1":
                return FRAME1_ARTWORK_MODEL_URL;
            case "frame1_pprt":
                return FRAME1_PPRT_ARTWORK_MODEL_URL;
            default:
                return DEFAULT_ARTWORK_MODEL_URL;
        }
    }

    static scaleFrame1_pprt(loadedMesh: any, outputWidth: number, outputHeight: number, frameThinkness: number, color: any, pasPartoutSize: number) {

        // Reduce frame size by pasPartoutSize on all sides to create constant border
        const frameWidth = outputWidth + pasPartoutSize
        const frameHeight = outputHeight + pasPartoutSize

        this.scaleFrame1(loadedMesh, frameWidth, frameHeight, frameThinkness, color)

        const paspartou = loadedMesh.getObjectByName("paspartou")
        if (paspartou) {
            paspartou.material = new THREE.MeshPhysicalMaterial({ color: 0xffffff, side: THREE.DoubleSide, roughness: 0.9, metalness: 0, emissive: 0xffffff, emissiveIntensity: 1 })
            // Passepartout keeps original dimensions, creating equal border around frame
            paspartou.scale.x = frameWidth
            paspartou.scale.y = frameHeight
        }
    }

    static scaleFrame1(loadedMesh: any, outputWidth: number, outputHeight: number, frameThinkness: number, color: any) {
        const outputWidth2 = outputWidth
        const outputHeight2 = outputHeight
        const material = new THREE.MeshPhysicalMaterial({ color: color, reflectivity: 0.5, roughness: 0.9, metalness: 0, side: THREE.DoubleSide })
        const frame_top = loadedMesh.getObjectByName("frame_top")
        if (frame_top) {
            frame_top.material = material
            frame_top.position.y = outputHeight2 / 2
            frame_top.scale.x = outputWidth
            frame_top.scale.y = frameThinkness
        }
        const frame_bottom = loadedMesh.getObjectByName("frame_bottom")
        if (frame_bottom) {
            frame_bottom.material = material
            frame_bottom.position.y = -outputHeight2 / 2
            frame_bottom.scale.x = outputWidth
            frame_bottom.scale.y = frameThinkness
        }
        const frame_left = loadedMesh.getObjectByName("frame_left")
        if (frame_left) {
            frame_left.material = material
            frame_left.position.x = -outputWidth2 / 2
            frame_left.scale.y = outputHeight
            frame_left.scale.x = frameThinkness
        }
        const frame_right = loadedMesh.getObjectByName("frame_right")
        if (frame_right) {
            frame_right.material = material
            frame_right.position.x = outputWidth2 / 2
            frame_right.scale.y = outputHeight
            frame_right.scale.x = frameThinkness
        }

        const frame_topleft = loadedMesh.getObjectByName("frame_topleft")
        if (frame_topleft) {
            frame_topleft.material = material
            frame_topleft.position.x = -outputWidth2 / 2
            frame_topleft.position.y = outputHeight2 / 2
            frame_topleft.scale.x = frameThinkness
            frame_topleft.scale.y = frameThinkness
        }
        const frame_topright = loadedMesh.getObjectByName("frame_topright")
        if (frame_topright) {
            frame_topright.material = material
            frame_topright.position.x = outputWidth2 / 2
            frame_topright.position.y = outputHeight2 / 2
            frame_topright.scale.x = frameThinkness
            frame_topright.scale.y = frameThinkness
        }
        const frame_bottomleft = loadedMesh.getObjectByName("frame_bottomleft")
        if (frame_bottomleft) {
            frame_bottomleft.material = material
            frame_bottomleft.position.x = -outputWidth2 / 2
            frame_bottomleft.position.y = -outputHeight2 / 2
            frame_bottomleft.scale.x = frameThinkness
            frame_bottomleft.scale.y = frameThinkness
        }
        const frame_bottomright = loadedMesh.getObjectByName("frame_bottomright")
        if (frame_bottomright) {
            frame_bottomright.material = material
            frame_bottomright.position.x = outputWidth2 / 2
            frame_bottomright.position.y = -outputHeight2 / 2
            frame_bottomright.scale.x = frameThinkness
            frame_bottomright.scale.y = frameThinkness
        }
    }
}
